module.exports = __webpack_public_path__ + "static/energy_1-e15ce487f60dbaf9a471b66a2cde4ba8.jpg";